import { useNavigate } from "react-router-dom";
import Layout from "../shared/Layout";
import PageHeader from "../shared/PageHeader";
import "../../css/conversations.css";
import "../../css/student-card.css";
import ConversationsDashboardStats from "./ConversationsDashboardStats";
import BotInfoPanel from "./BotInfoPanel";
import TelegramUsageChart from "../dashboard/TelegramUsageChart";
import ConversationsPeopleWidget from "./ConversationsPeopleWidget";
import TelegramUsersWidget from "./TelegramUsersWidget";
import ConversationTemplatesSection from "./ConversationTemplatesSection";
import IconAdd from "../../components/icons/IconAdd";
import usePersistedState from "../../hooks/usePersistedState";

export default function ConversationMainView() {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = usePersistedState("conversations-menu-tab", "templates");

    return (
        <Layout>
            <PageHeader name="Бот">
                <div className="groups-add-btn" onClick={() => navigate("/conversations-ai-generator")} title="Згенерувати тест за допомогою AI">
                    <IconAdd />
                </div>
            </PageHeader>
            <main className="main-block">
                <div className="main-content txt-c conv-dashboard-page">
                    <div className="student-card-tabs">
                        <div className={"student-card-tab" + (activeTab === "templates" ? " active" : "")} onClick={() => setActiveTab("templates")}>
                            Шаблони тестів
                        </div>
                        <div className={"student-card-tab" + (activeTab === "usage" ? " active" : "")} onClick={() => setActiveTab("usage")}>
                            Бот використання
                        </div>
                    </div>

                    {activeTab === "templates" ? (
                        <div>
                            <div className="conv-dashboard-link-row">
                                <span className="conv-dashboard-link" onClick={() => navigate("/conversations-ai-generator")}>
                                    Згенерувати тест за допомогою AI →
                                </span>
                            </div>
                            <ConversationTemplatesSection />
                        </div>
                    ) : ""}

                    {activeTab === "usage" ? (
                        <div>
                            <ConversationsDashboardStats />

                            <div className="conv-dashboard-columns">
                                <div>
                                    <BotInfoPanel />
                                    <ConversationsPeopleWidget />
                                </div>
                                <div>
                                    <div className="conv-dashboard-section">
                                        <h4 className="conv-dashboard-section-title">Активність</h4>
                                        <TelegramUsageChart />
                                    </div>

                                    <TelegramUsersWidget />
                                </div>
                            </div>
                        </div>
                    ) : ""}
                </div>
            </main>
        </Layout>
    );
}
